module.exports = __webpack_public_path__ + "static/media/211231_GKC_Cam_02.89a9edaf.webp";